<template>
<div class="chapter">
<div class="inner_page">
<div class="frame-2"><img alt="41228.jpg" class="frame-1a" src="Images/41228.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Cover.vue?c8fb8cfa